<script setup lang="ts">
import { useComponentClasses } from "../../composables";

const { root } = useComponentClasses("ui-modal-description");

const rootClass = root();
</script>

<template>
  <p :class="rootClass">
    <slot />
  </p>
</template>

<style scoped>
.ui-modal-description {
  color: var(--ui-color-text-muted);
  font-size: var(--ui-font-size-md);
  line-height: var(--ui-line-height-normal, 1.5rem);
  font-weight: var(--ui-font-weight-normal);
}
</style>
